/**
 * Common Tab Menu Data for Student Pages
 * Contains tab menu configuration shared across student pages
 */

import React from 'react';
import { ReactComponent as BookIcon } from '../../../assets/images/icons/books.svg';
import { ReactComponent as MyExamsIcon } from '../../../assets/images/icons/exam.svg';

/**
 * Get base tab menu data (without Question World)
 * @returns {Array} Array of tab menu items
 */
export const getBaseTabMenuData = () => [
  {
    key: 'courses',
    title: 'My Courses',
    url: '/courses',
    icon: <BookIcon className="rd-tab-menu-icon" style={{ color: '#F16D6D' }} />
  },
  {
    key: 'exams',
    title: 'My Exams',
    url: '/exams',
    icon: <MyExamsIcon className="rd-tab-menu-icon" style={{ color: '#EDAA8C' }} />
  }
];

/**
 * Get Question World tab menu item
 * @returns {Object} Question World tab menu item
 */
export const getQuestionWorldTabMenuItem = () => ({
  key: 'question-world',
  title: 'Q. World',
  url: '/question-world',
  icon: <MyExamsIcon className="rd-tab-menu-icon" style={{ color: '#662d91' }} />
});

/**
 * Get complete tab menu data with optional Question World
 * @param {boolean} includeQuestionWorld - Whether to include Question World tab
 * @returns {Array} Array of tab menu items
 */
export const getTabMenuData = (includeQuestionWorld = false) => {
  const baseTabs = getBaseTabMenuData();
  
  if (includeQuestionWorld) {
    return [...baseTabs, getQuestionWorldTabMenuItem()];
  }
  
  return baseTabs;
};

